
// Helper function to format call duration
export const formatCallDuration = (totalSeconds) => {
  // const minutes = Math.floor(seconds / 60);
  // const remainingSeconds = seconds % 60;
  // return `${minutes.toString().padStart(2, '0')}:${remainingSeconds.toString().padStart(2, '0')}`;

  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;

  return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
};

export const countryOptions = [
  { Code: "US", Country: "United States (+1)" },
  { Code: "CA", Country: "Canada (+1)" },
  { Code: "GB", Country: "United Kingdom (+44)" },
  { Code: "AU", Country: "Australia (+61)" },
  { Code: "DE", Country: "Germany (+49)" },
];

export const CALL_CONFIRMATION = "Are you sure you want to call this number?";